import React, { useState } from 'react';

import { InputV2 } from '@depop/web-ui-kit/InputV2';
import { getCookie, setCookie } from 'cookies-next/client';

import { GEO_SWITCH_KEY } from '@/constants/cookies';

export function GeoSwitch() {
  const [value, setValue] = useState(getCookie(GEO_SWITCH_KEY));

  function updateValue(value: string) {
    const countryCode = value.trim().toUpperCase();
    setValue(countryCode);
    setCookie(GEO_SWITCH_KEY, countryCode);
  }

  return (
    <InputV2
      labelText="Country code (eg. GB, US, AU)"
      id="adminTool__geoSwitch"
      value={value}
      onChange={(e) => updateValue(e.target.value)}
      onClear={() => updateValue('')}
    />
  );
}
